/* eslint-disable @typescript-eslint/no-explicit-any */

import { encryptAes256CbcOpenSsl } from './encrypt.util';
import { getCookie } from './cookies.util';

export class ServerFetchError extends Error {
  status: number;

  constructor(status: number) {
    super(`Fetch failed with status ${status}`);
    this.name = 'ServerFetchError';
    this.status = status;
  }
}

interface ServerFetchOptions {
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  queryParams?: Record<string, any>;
  body?: any;
  includeAuth?: boolean;
  token?: string | null;
}

export const serverFetch = async <T = any>({
  endpoint,
  method = 'GET',
  queryParams,
  body,
  includeAuth = true,
  token = null,
}: ServerFetchOptions): Promise<T> => {
  const createdAt = new Date().getTime();
  const password = `${process.env.NEXT_PUBLIC_APP_ENCRYPTION_KEY}${createdAt}`;
  const apiKey = encryptAes256CbcOpenSsl(password, process.env.NEXT_PUBLIC_APP_ENCRYPTION_KEY ?? '');

  const accessToken = !token
    ? includeAuth
      ? getCookie('token') || ''
      : ''
    : token;

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
    appType: 'Customer',
    createdAt: createdAt.toString(),
    apikey: apiKey,
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };

  const queryString = queryParams
    ? '?' + new URLSearchParams(queryParams).toString()
    : '';

  const response = await fetch(`${endpoint}${queryString}`, {
    method,
    headers,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (!response.ok) {
    throw new ServerFetchError(response.status);
  }

  const data: T = await response.json();
  return data;
};